"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";

export function AdvSearchAmenitiesDropdown({}) {
  return (
    <Block className={"amenities-group"} tag={"div"}>
      <Block className={" adv-search-lable"} tag={"div"}>
        {"Move-in"}
      </Block>
      <Block className={"div-block-69"} tag={"div"}>
        <Block className={"bedroom-group"} tag={"div"}>
          {"Amenities"}
        </Block>
      </Block>
      <Block
        className={"adv-search-drop-down-amenity-popover-copy"}
        tag={"div"}
      />
    </Block>
  );
}
